/**
 * PostHog funnel tracking — quiz landing, quiz questions (DOM fallback), taste profile, Dragon Slayer, Father's Day.
 */
(function () {
  'use strict';

  function ph() {
    return window.whiskyPosthog;
  }

  function track(event, properties) {
    var w = ph();
    if (!w) return;
    w.capture(event, w.funnelContext(properties));
  }

  function templateSuffix() {
    if (!window._template) return '';
    return window._template.suffix || window._template.name || '';
  }

  function isFunnelPage() {
    var s = templateSuffix();
    if (!s) return false;
    return (
      s.indexOf('quiz') !== -1 ||
      s.indexOf('taste-profile') !== -1 ||
      s.indexOf('dragon-slayer') !== -1 ||
      s.indexOf('father-day') !== -1
    );
  }

  function initQuizNavSource() {
    var w = ph();
    if (!w) return;
    var source = w.getQuizNavSource();
    if (source) w.register({ quiz_nav_source: source });
  }

  function initFunnelPageView() {
    if (!isFunnelPage()) return;
    track('funnel_page_viewed', {
      funnel_page: templateSuffix(),
      funnel_step: funnelStepFromSuffix(templateSuffix())
    });
  }

  function funnelStepFromSuffix(suffix) {
    if (suffix === 'quiz-landing' || suffix === 'quiz-landing-v2') return 'landing';
    if (suffix === 'quiz-questions') return 'quiz';
    if (suffix === 'taste-profile' || suffix === 'taste-profile-v2') return 'taste_profile';
    if (suffix === 'dragon-slayer') return 'dragon_slayer';
    if (suffix && suffix.indexOf('father-day') !== -1) return 'father_day';
    return suffix;
  }

  function initQuizLandingMilestoneUser() {
    var s = templateSuffix();
    if (s !== 'quiz-landing' && s !== 'quiz-landing-v2') return;

    function apply() {
      var w = ph();
      if (w && typeof w.setMilestoneUserOnce === 'function') {
        w.setMilestoneUserOnce();
      } else if (w && typeof w.setFirstSeenAtOnce === 'function') {
        w.setFirstSeenAtOnce();
      }
    }

    var w = ph();
    if (w && typeof w.isSdkReady === 'function' && w.isSdkReady()) {
      apply();
      return;
    }
    window.addEventListener('whisky-posthog-ready', apply, { once: true });
  }

  function initQuizLandingClicks() {
    var s = templateSuffix();
    if (s !== 'quiz-landing' && s !== 'quiz-landing-v2') return;

    document.addEventListener(
      'click',
      function (e) {
        var link = e.target.closest('a[href*="quiz-questions"]');
        if (!link) return;
        track('quiz_landing_cta_clicked', {
          cta_href: link.getAttribute('href'),
          cta_text: (link.textContent || '').trim().slice(0, 120),
          cta_location: link.closest('section') ? link.closest('section').id || link.className : link.className
        });
      },
      true
    );
  }

  function initTasteProfileObservers() {
    var suffix = templateSuffix();
    if (suffix !== 'taste-profile' && suffix !== 'taste-profile-v2') return;

    var pageRoot = document.querySelector('.taste-profile-page');
    if (!pageRoot) return;

    var profileReported = false;
    var loadingClearedReported = false;

    function reportProfileShown() {
      if (profileReported) return;
      var result = pageRoot.getAttribute('data-taste-profile');
      if (!result) return;
      profileReported = true;
      track('taste_profile_revealed', {
        taste_profile: result,
        selected_tier: pageRoot.getAttribute('data-selected-tier') || null
      });
      var w = ph();
      if (w) {
        w.register({
          taste_profile_result: result,
          taste_profile_selected_tier: pageRoot.getAttribute('data-selected-tier') || ''
        });
      }
    }

    function reportLoadingComplete() {
      if (loadingClearedReported) return;
      if (pageRoot.classList.contains('taste-profile-page--loading')) return;
      loadingClearedReported = true;
      track('taste_profile_content_ready', {
        taste_profile: pageRoot.getAttribute('data-taste-profile') || null
      });
      reportProfileShown();
    }

    if (typeof MutationObserver !== 'undefined') {
      new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
          if (m.attributeName === 'data-taste-profile') reportProfileShown();
          if (m.attributeName === 'class') reportLoadingComplete();
        });
      }).observe(pageRoot, {
        attributes: true,
        attributeFilter: ['data-taste-profile', 'data-selected-tier', 'class']
      });
    }

    document.addEventListener('tp:tier-request', function (e) {
      var tier = e.detail && e.detail.tier;
      if (!tier) return;
      track('taste_profile_tier_selected', {
        tier: tier,
        taste_profile: pageRoot.getAttribute('data-taste-profile') || null
      });
    });

    var tierReported = {};
    document.addEventListener(
      'click',
      function (e) {
        var card = e.target.closest('.tpf-card[data-tier]');
        if (card) {
          track('taste_profile_tier_card_clicked', {
            tier: card.getAttribute('data-tier'),
            source: 'card'
          });
          return;
        }
        var tab = e.target.closest('.tp-tier-mobile-switcher__item[data-tier]');
        if (tab) {
          track('taste_profile_tier_tab_clicked', {
            tier: tab.getAttribute('data-tier'),
            source: 'mobile_tab'
          });
        }
      },
      true
    );

    setTimeout(reportLoadingComplete, 500);
    setTimeout(reportProfileShown, 1500);
  }

  function initDragonSlayerAndFatherDay() {
    var suffix = templateSuffix();
    var isDs = suffix === 'dragon-slayer';
    var isFd = suffix && suffix.indexOf('father-day') !== -1;
    if (!isDs && !isFd) return;

    document.addEventListener(
      'click',
      function (e) {
        var cta = e.target.closest('[data-dsl-explorer-checkout]');
        if (!cta) return;
        track(isDs ? 'dragon_slayer_checkout_cta_clicked' : 'father_day_checkout_cta_clicked', {
          tier_key: cta.getAttribute('data-tier-key') || cta.getAttribute('data-tier') || null,
          cta_text: (cta.textContent || '').trim().slice(0, 80),
          in_offer_section: !!cta.closest('.fd-offer__cta-wrap, .dsl-hiw, [data-section]')
        });
      },
      true
    );

    document.addEventListener(
      'click',
      function (e) {
        var scrollCta = e.target.closest('[data-dsl-scroll-to-offer], [data-fd-scroll-to-offer]');
        if (!scrollCta) return;
        track('funnel_scroll_to_offer_clicked', { funnel_page: suffix });
      },
      true
    );
  }

  /** DOM fallback if React bundle does not emit custom events (older builds). */
  function initQuizQuestionsDomFallback() {
    if (templateSuffix() !== 'quiz-questions') return;

    var reported = { started: false, email: false };
    var lastQuestionKey = '';

    function poll() {
      var quiz = document.querySelector('.quiz');
      if (!quiz) return;

      if (!reported.started && document.querySelector('.quiz__question')) {
        reported.started = true;
        track('quiz_started', { source: 'dom_fallback' });
      }

      var qEl = document.querySelector('.quiz__question');
      if (qEl) {
        var qText = (qEl.textContent || '').trim().slice(0, 200);
        if (qText && qText !== lastQuestionKey) {
          lastQuestionKey = qText;
          var counter = document.querySelector('.quiz__counter');
          track('quiz_question_viewed', {
            question_text: qText,
            counter: counter ? (counter.textContent || '').trim() : null,
            source: 'dom_fallback'
          });
        }
      }

      if (!reported.email && document.querySelector('.quiz__email-section')) {
        reported.email = true;
        track('quiz_email_step_viewed', { source: 'dom_fallback' });
      }
    }

    document.addEventListener(
      'click',
      function (e) {
        var opt = e.target.closest('.quiz__option');
        if (!opt) return;
        track('quiz_answer_selected', {
          answer_label: (opt.querySelector('.quiz__option-label') || opt).textContent.trim().slice(0, 120),
          source: 'dom_fallback'
        });
      },
      true
    );

    setInterval(poll, 800);
    poll();
  }

  function initRetakeLink() {
    document.addEventListener(
      'click',
      function (e) {
        var link = e.target.closest('a[href*="quiz-questions"][href*="retake"]');
        if (!link) return;
        track('quiz_retake_clicked', { href: link.getAttribute('href') });
      },
      true
    );
  }

  function initAll() {
    initQuizNavSource();
    initFunnelPageView();
    initQuizLandingMilestoneUser();
    initQuizLandingClicks();
    initTasteProfileObservers();
    initDragonSlayerAndFatherDay();
    initQuizQuestionsDomFallback();
    initRetakeLink();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
